import { Channel, deviceUtils } from 'scbk-services';

import { SecureKeypadType } from '../enums/SecureKeypadTypeEnum';

// import { scriptUtils } from 'scbk-shared-module/utils';

import {
  SecureKeypadContext,
  SecureKeypadDriver,
  SecureKeypadFieldId,
  SecureKeypadFieldOption,
} from '../types/types';

export class VirtualKeypadDriver implements SecureKeypadDriver {
  // private static instance: VirtualKeypadDriver | null = null;

  private initialized = false;

  private optionRegistry = new Map<SecureKeypadFieldId, SecureKeypadFieldOption>();

  private elementRegistry = new Map<SecureKeypadFieldId, HTMLElement>();

  readonly id = 'virtual';

  // public static getInstance(): VirtualKeypadDriver {
  //   if (!VirtualKeypadDriver.instance) {
  //     VirtualKeypadDriver.instance = new VirtualKeypadDriver();
  //   }
  //   return VirtualKeypadDriver.instance;
  // }

  constructor() {}

  /**
   * 지원여부
   * @param ctx 컨텍스트
   * @returns
   */
  supported(ctx: SecureKeypadContext): boolean {
    // 모바일 뱅킹, 인터넷 뱅킹
    // 모바일 웹 or (인터넷 뱅킹 && OS : Windows 아닐 때)

    // if (import.meta.env.VITE_ENV === 'local') {
    //   return (
    //     (ctx.virtualOnly && ctx.channel !== Channel.MB) ||
    //     ctx.channel === Channel.MW ||
    //     (ctx.channel === Channel.IB && deviceUtils.isWin())
    //   );
    // }

    return (
      (ctx.virtualOnly && ctx.channel !== Channel.MB) ||
      ctx.channel === Channel.MW ||
      (ctx.channel === Channel.IB && !deviceUtils.isWin())
    );
  }

  /**
   * 초기화 수행
   * @param ctx
   */
  init(ctx: SecureKeypadContext) {
    // console.log('# VirtualKeypadDriver init ctx');

    if (typeof window === 'undefined') {
      return;
    }

    this.initOnce(ctx);
  }

  destroy() {
    this.initialized = false;
    this.optionRegistry.clear();
    this.elementRegistry.clear();
  }

  /**
   * 키패드 등록
   * @param el 입력요소
   * @param option 키패드 옵션
   * @returns
   */
  register(el: HTMLInputElement, option?: SecureKeypadFieldOption) {
    const w = window as any;
    w.nshc = w.nshc ?? {};
    if (!el) {
      return;
    }

    const _opt = this.mergeOptions(el.id, option);
    if (!_opt) {
      return;
    }

    this.optionRegistry.set(_opt.fieldId, _opt);

    // el.setAttribute('readonly', 'true');

    let type = '';
    const dataEnc = el.getAttribute('data-enc');
    if (dataEnc === 'num') {
      type = SecureKeypadType.Num;
    } else if (dataEnc === 'qwerty') {
      type = SecureKeypadType.Qwerty;
    } else {
      type = SecureKeypadType.Default;
    }

    if (w.nshc.setCommon) {
      // pcCKpd : PC 문자키패드
      // mCKpd : 모바일 문자키패드
      // nAKpd : 3x4 숫자키패드
      // nBKpd : 4x3 숫자키패드
      // nCKpd : 2x6 숫자키패드
      let keymode = '';
      switch (type) {
        case SecureKeypadType.Num:
          keymode = deviceUtils.isPC() ? 'nCKpd' : 'nBKpd';
          break;
        case SecureKeypadType.Qwerty:
        case SecureKeypadType.Default:
          keymode = deviceUtils.isPC() ? 'pcCKpd' : 'mCKpd';
          break;
      }

      w.nshc.setCommon(el, `mode=${keymode}`);
    }

    this.elementRegistry.set(el.id, el);

    // w.nshc?.setInit();
  }

  /**
   * 키패드 unregister
   * @param el
   */
  unregister(el: HTMLInputElement) {
    this.elementRegistry.delete(el.id);
  }

  /**
   * 키패드 open
   * @param fieldId 필드 ID
   * @returns
   */
  async open(fieldId: SecureKeypadFieldId): Promise<void> {
    const el = this.elementRegistry.get(fieldId);
    if (!el) {
      return;
    }

    console.log('### fieldId : ', fieldId);

    el.focus();
  }

  /**
   * 키패드를 닫는다.
   * @param fieldId 필드 ID
   */
  close(fieldId: SecureKeypadFieldId) {
    const el = this.elementRegistry.get(fieldId);
    if (!el) {
      return;
    }

    console.log('# close fieldId', fieldId);

    const w = window as any;
    w.nshc = w.nshc ?? {};

    w.nshc.closeKpd();
  }

  /**
   * 키패드 값  초기화
   */
  clear(fieldId?: SecureKeypadFieldId) {
    if (fieldId) {
      const el = this.elementRegistry.get(fieldId);
      if (!el) {
        return;
      }

      const elOri = document.getElementById(`${el.id}`) as HTMLInputElement;
      const elNFilter = document.getElementById(`${el.id}_nfilter_sec`) as HTMLInputElement;

      elOri.value = '';
      elNFilter.value = '';
    } else {
      const registry = this.elementRegistry;
      if (!registry) {
        return;
      }

      const idsArr = Array.from(this.elementRegistry.keys());

      idsArr.map((key) => {
        const elOri = document.getElementById(`${key}`) as HTMLInputElement | null;
        const elNFilter = document.getElementById(`${key}_nfilter_sec`) as HTMLInputElement | null;

        if (!elOri || !elNFilter) {
          return;
        }

        elOri.value = '';
        elNFilter.value = '';
      });
    }
  }

  /**
   * 암호화된 값 return
   */
  getEncData(): Promise<Record<string, string | Record<string, string>>> {
    return new Promise((resolve) => {
      const w = window as any;
      w.nshc = w.nshc ?? {};

      const encData = {
        encType: 'openWebNFilter',
        encValue: encodeURIComponent(w.nshc.encrypted()),
      };

      resolve(encData);
    });
  }

  /**
   *
   * @param fieldId
   * @returns
   */
  getOptions(fieldId: SecureKeypadFieldId): SecureKeypadFieldOption | undefined {
    return this.optionRegistry.get(fieldId as SecureKeypadFieldId);
  }

  forEachInput(callback: (el: HTMLElement) => void) {
    return this.elementRegistry.forEach(callback);
  }

  /**
   * 초기화를 한번만 수행한다.
   * @param ctx 컨텍스트
   * @returns
   */
  private initOnce(ctx: SecureKeypadContext) {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    const w = window as any;

    w.nshc = w.nshc ?? {};

    const opts: SecureKeypadFieldOption[] = ctx.options ?? [];

    if (!opts) {
      console.warn('options is null or undefined');
    }

    if (opts) {
      opts.forEach((opt) => {
        this.optionRegistry.set(opt.fieldId, opt);
      });
    }

    w.nshc.ownCallback = (type: string, id: string) => {
      const opt = this.optionRegistry.get(id);
      if (!opt) {
        return;
      }

      const { fieldId } = opt;

      const elOri = document.getElementById(`${opt.fieldId}`) as HTMLInputElement;
      elOri && elOri.dispatchEvent(new Event('change', { bubbles: true }));

      switch (type) {
        case 'open': {
          elOri.setAttribute('data-keypad-opening', 'Y');
          break;
        }
        case 'enter': {
          const el = document.getElementById(`${opt.fieldId}_nfilter_sec`);
          if (!el) {
            return;
          }

          const encData = el.getAttribute('value');

          opt.setEncData?.(); // 암호화 SecureContext에 데이터 저장
          opt.onComplete?.({
            fieldId,
            encData: encData ?? '',
            length: elOri.value.length,
          });
          elOri?.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
          elOri.setAttribute('data-keypad-opening', '');
          break;
        }
        case 'close': {
          opt.onClose?.({
            fieldId,
          });
          elOri?.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
          elOri.setAttribute('data-keypad-opening', '');
          break;
        }
        case 'nfilter_renew': {
          // 자판 섞기
          break;
        }
        case 'nfilter_clear': {
          opt.onClear?.({
            fieldId,
          });
          break;
        }
      }
    };

    //w.nshc.setOnInitStart();

    if (ctx.channel === Channel.MB || ctx.channel === Channel.MW) {
      if (w.setNFilterMobileInit) {
        w.setNFilterMobileInit();
      }
    } else if (ctx.channel === Channel.IB) {
      if (w.setNFilterInit) {
        w.setNFilterInit();
      }
    }
  }

  /**
   * 초기 기본 옵션과 필드 등록시 전달된 옵션을 merge한다.
   * @param fieldId 필드 ID
   * @param option 필드 등록 시 전달된 옵션
   * @returns
   */
  private mergeOptions(
    fieldId: string,
    option?: SecureKeypadFieldOption,
  ): SecureKeypadFieldOption | undefined {
    const defaultOption = this.optionRegistry.get(fieldId);
    if (!option) {
      return defaultOption;
    }

    return {
      ...defaultOption,
      ...option,
    };
  }
}
